import { render, staticRenderFns } from "./AttachmentsMenu.vue?vue&type=template&id=1687cfc6&"
import script from "./AttachmentsMenu.vue?vue&type=script&lang=js&"
export * from "./AttachmentsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports